import { FunctionData } from "./functionData";
import { TreeViewNode } from "../components/TreeView/treeViewNode";
export class ClassData {
    constructor() {
        //All classes
        this.id = "";
        this.name = "";
        this.description = "";
        this.example = "";
        this.functions = new Array();
        this._treeViewNode = null;
    }
    deserialize(input) {
        this.id = input.id;
        this.name = input.name;
        this.description = input.description;
        this.example = input.example;
        this.functions.length = 0;
        if (input.functions) {
            for (const jsonFunction of input.functions) {
                this.functions.push(new FunctionData().deserialize(jsonFunction));
            }
        }
        return this;
    }
    getTreeViewNode() {
        if (!this._treeViewNode) {
            const children = new Array();
            if (this.example) {
                children.push(new TreeViewNode("Example", this.example, []));
            }
            if (this.functions.length > 0) {
                for (const aFunction of this.functions) {
                    children.push(aFunction.getTreeViewNode());
                }
            }
            this._treeViewNode = new TreeViewNode(this.name, this.description, children);
        }
        return this._treeViewNode;
    }
}
